import { CandidateTab } from 'features/Principal/types/modalTypes';

export const candidateTabs: CandidateTab[] = [
  {
    value: 0,
    label: 'Basic Info',
    isResume: false,
  },
  {
    value: 1,
    label: 'Qualifications',
    isResume: false,
  },
  {
    value: 2,
    label: 'Experience',
    isResume: false,
  },
  {
    value: 3,
    label: 'Resume',
    isResume: true,
  },
  {
    value: 4,
    label: 'Application',
    isResume: false,
  },
  {
    value: 5,
    label: 'Other Attachments',
    isResume: false,
  },
];
